import React from 'react';
import { usePWA } from '../context/PWAContext';
import './OfflineIndicator.css';

const OfflineIndicator: React.FC = () => {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null;
  }

  return (
    <div className="offline-indicator">
      <div className="offline-content">
        <span className="offline-icon">📡</span>
        <span className="offline-text">You're offline - some features may be limited</span>
      </div>
    </div>
  );
};

export default OfflineIndicator;
